import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const MARKETPLACE_LABELS = {
    walmart: 'Walmart',
    etsy: 'Etsy',
    ebay: 'eBay',
    amazon: 'Amazon',
    shopify: 'Shopify',
};

/**
 * Generic Marketplace OAuth Error Page
 *
 * Works for all marketplaces. Reads `marketplace`, `code`, and `message` from URL params.
 *
 * URL params (from adapter callback):
 *   - code: Error code (e.g., 'OAUTH_FAILED', 'ETSY_OAUTH_FAILED')
 *   - message: Human-readable error message
 *   - marketplace: Which marketplace failed (optional — falls back to URL path)
 */
const MarketplaceOAuthError = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const marketplace = searchParams.get('marketplace') || 'marketplace';
    const label = MARKETPLACE_LABELS[marketplace] || marketplace;
    const errorMessage = searchParams.get('message') || `Failed to connect your ${label} account.`;

    const handleRedirectionClick = () => {
        navigate('/marketplace-integration');
    };

    return (
        <main>
            <div className="main__container">
                <div className="cus-page-content-sec">
                    <div className="top_right_button_container cus-content-only-sec">
                        <div className='incoming_wrapper main_content_table addressDetailWrapper'>
                            <div className='statusRedirect error'>
                                <div className='icon error'>
                                    <i className="fa fa-times" aria-hidden="true"></i>
                                </div>
                                <h2 className='mb-10'>Access Denied</h2>
                                <p>{errorMessage}</p>
                                <button
                                    className="btn cus-primary-transparent-btn"
                                    onClick={handleRedirectionClick}
                                >
                                    Back to Integration
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default MarketplaceOAuthError;
